"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoPriorityBasedPolicyMiddleware = void 0;
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _types = require("../../actions/meeting/types");
var _types2 = require("../../actions/program/types");
var _utils = require("./utils");
var _audioVideoHelpers = require("@studio/chime/audioVideo/audioVideoHelpers");
var _videoSharedState = require("./videoSharedState");
var _featureFlags = require("@studio/feature.flags/featureFlags");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _Meeting = require("@studio/constants/Meeting");
var _Vendor = require("@studio/constants/Vendor");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var logger = new _StudioLogger.StudioLogger('videoPriorityBasedPolicyMiddleware');
var getAllSourceIds = function getAllSourceIds(previousVideoPreferences) {
  var sourceIds = [];
  // Iterate over previousVideoPreferences to get all source ids
  // NOTE: Can't filter here it's not an array...
  var _iterator = _createForOfIteratorHelper(previousVideoPreferences),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var src = _step.value;
      if (src.attendeeId) {
        sourceIds.push(src.attendeeId);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return sourceIds;
};
function meetingStarted(type, payload) {
  return type === _types.UPDATE_MEETING_STATUS && payload === _Meeting.MEETING_STATUS.STARTED;
}
function shouldRunMiddleware($action) {
  var type = $action.type,
    payload = $action.payload;
  return type === _types2.BROADCAST_SET_PROGRAM || meetingStarted(type, payload);
}
var videoPriorityBasedPolicyMiddleware = exports.videoPriorityBasedPolicyMiddleware = function videoPriorityBasedPolicyMiddleware(store) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(action) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              (0, _rxjs.from)([action]).pipe((0, _operators.filter)(function ($action) {
                return shouldRunMiddleware($action);
              })).subscribe(function ($action) {
                var _stateProgram$program, _meetingSession$audio;
                var useAgora = (0, _featureFlags.shouldHaveFeature)('studio.meetingVendor') === _Vendor.VENDOR_AGORA;
                var type = $action.type,
                  payload = $action.payload;
                if (!(0, _featureFlags.shouldHaveFeature)('studio.onStagePriority') || useAgora) {
                  return;
                }
                var _store$getState = store.getState(),
                  meetingSession = _store$getState.meeting.meetingSession,
                  _store$getState$progr = _store$getState.program,
                  _stateProgram = _store$getState$progr === void 0 ? {} : _store$getState$progr;

                // Mixer for some reason has the program in a different object structure
                // Ticket to fix it - Fast follow - WEBINAR-46926
                var stateProgram = (_stateProgram$program = _stateProgram === null || _stateProgram === void 0 ? void 0 : _stateProgram.program) !== null && _stateProgram$program !== void 0 ? _stateProgram$program : _stateProgram;
                var program = type === _types2.BROADCAST_SET_PROGRAM ? payload : stateProgram;

                // Get the camera and screen share sources that are currently in the program.
                var cameraAndScreenShareSourcesInProgram = (0, _utils.getCameraAndScreenShareSourcesInProgram)(program);
                (0, _videoSharedState.setSharedCameraAndScreenShareSourcesInProgram)(cameraAndScreenShareSourcesInProgram);

                // In case the middleware is called before the chime meeting is initialized.
                if (!meetingSession || !meetingSession.audioVideo) {
                  return;
                }

                /**
                 *----------------------------------------------
                 * Uplink Priority
                 * ---------------------------------------------
                 */

                /**
                 * Enable priority on the uplink policy
                 * i.e. If I (current attendee) am on stage and there are at most 2 sources on stage
                 * then set priority on uplink policy. It means sending higher resolution than what would be sent otherwise
                 */
                if ((0, _featureFlags.shouldHaveFeature)('studio.onStageUplinkPriority')) {
                  var _meetingSession$confi;
                  var currentAttendeeId = meetingSession.configuration.credentials.attendeeId;
                  var uplinkPolicy = (_meetingSession$confi = meetingSession.configuration) === null || _meetingSession$confi === void 0 ? void 0 : _meetingSession$confi.videoUplinkBandwidthPolicy;
                  if (uplinkPolicy) {
                    var isCurrentAttendeeOnStage = cameraAndScreenShareSourcesInProgram.includes(currentAttendeeId);

                    /**
                     * We mark the stage as overcrowded if it has more than specified no. of sources
                     * When stage becomes overcrowded, we'll not apply the uplink policy as speakers will be shown
                     * in smaller tiles and increased resolution from uplink priority will not be useful
                     */
                    var isStageOvercrowded = cameraAndScreenShareSourcesInProgram.length > 2;

                    /**
                     * If uplink priority is currently set, we need to unset it if:
                     *  - Current attendee is removed from stage
                     *  - Or stage becomes overcrowded
                     */
                    if (uplinkPolicy.hasUplinkPriority && (!isCurrentAttendeeOnStage || isStageOvercrowded)) {
                      uplinkPolicy.setHasUplinkPriority(false);
                      uplinkPolicy.updateTransceiverController();
                    }

                    /**
                     * If uplink priority is not currently set, we need to set it if:
                     *  - Current attendee is put on stage
                     *  - And stage is not overcrowded
                     */
                    if (!uplinkPolicy.hasUplinkPriority && isCurrentAttendeeOnStage && !isStageOvercrowded) {
                      uplinkPolicy.setHasUplinkPriority(true);
                      uplinkPolicy.updateTransceiverController();
                    }
                  }
                }

                /**
                 *----------------------------------------------
                 * Downlink Priority
                 * ---------------------------------------------
                 */

                var isVideoDownlinkBandwidthPolicyDefined = !!(meetingSession !== null && meetingSession !== void 0 && (_meetingSession$audio = meetingSession.audioVideo) !== null && _meetingSession$audio !== void 0 && (_meetingSession$audio = _meetingSession$audio.audioVideoController) !== null && _meetingSession$audio !== void 0 && (_meetingSession$audio = _meetingSession$audio.meetingSessionContext) !== null && _meetingSession$audio !== void 0 && _meetingSession$audio.videoDownlinkBandwidthPolicy);
                if (!isVideoDownlinkBandwidthPolicyDefined) {
                  return;
                }

                // Get the previous video preferences.. these are the remote video sources that are currently being shown
                var previousVideoPreferences = (0, _videoSharedState.getSharedPreviousVideoPreferences)();

                // Get all source ids from previous video preferences
                var allSourceIds = getAllSourceIds(previousVideoPreferences);

                // Filter out anyone from the program that doesn't have a video source
                var filteredCameraAndScreenShareSourcesInProgram = cameraAndScreenShareSourcesInProgram.filter(function (src) {
                  return allSourceIds.includes(src);
                });

                // Filter out anyone that has a video source but is not in the program
                var cameraAndScreenShareSourcesNotInProgram = allSourceIds.filter(function (src) {
                  return !filteredCameraAndScreenShareSourcesInProgram.includes(src);
                });
                var newVideoPreferences = (0, _utils.buildVideoPreferences)(filteredCameraAndScreenShareSourcesInProgram, cameraAndScreenShareSourcesNotInProgram);
                if (!(0, _utils.areVideoPreferencesEqual)(previousVideoPreferences, newVideoPreferences)) {
                  logger.info('Chime video priority updated based on stage presence', {
                    onStageCount: filteredCameraAndScreenShareSourcesInProgram.length,
                    onStageIds: filteredCameraAndScreenShareSourcesInProgram,
                    notOnStageCount: cameraAndScreenShareSourcesNotInProgram.length,
                    notOnStageIds: cameraAndScreenShareSourcesNotInProgram
                  });

                  // Updating the video preferences should not be catastrophic, so we'll catch any errors here
                  try {
                    (0, _audioVideoHelpers.chooseRemoteVideoSources)(meetingSession, newVideoPreferences);
                    (0, _videoSharedState.setSharedPreviousVideoPreferences)(newVideoPreferences);
                  } catch (e) {
                    logger.error('Chime video priority update failed', {
                      err: e.message,
                      newVideoPreferences: newVideoPreferences
                    });
                  }
                }
              });
              return _context.a(2, next(action));
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};